var map = {
	"./addrounded.svg": 72254,
	"./authoruser.svg": 78732,
	"./blacksearch.svg": 28176,
	"./blackshare.svg": 9229,
	"./bredrightarrow.svg": 81413,
	"./calendericon.svg": 68372,
	"./circledownarrow.svg": 45980,
	"./clock.svg": 77062,
	"./close.svg": 39525,
	"./downarrow.svg": 63300,
	"./facebookcolorround.svg": 12742,
	"./facebookicon.svg": 71318,
	"./instagramcollection.svg": 36299,
	"./instagramcolorround.svg": 96010,
	"./linkedin.svg": 49097,
	"./linkedinicon.svg": 77358,
	"./longrightarrow.svg": 18123,
	"./mailicon.svg": 8090,
	"./newsletterimg.svg": 74691,
	"./rightarrow.svg": 64599,
	"./rightarrowblue.svg": 39481,
	"./search.svg": 66759,
	"./searchfilter.svg": 38237,
	"./share.svg": 43693,
	"./share2.svg": 2402,
	"./shareblueicon.svg": 69513,
	"./shareicon.svg": 82735,
	"./sliderlefttarrow.svg": 43717,
	"./sliderrightarrow.svg": 90872,
	"./telegramcolorround.svg": 57647,
	"./twittercolorround.svg": 38008,
	"./twittericon.svg": 32003,
	"./whatsappcolorround.svg": 91310,
	"./whatsappicon.svg": 39801,
	"./whiterightarrow.svg": 2284,
	"./whitesearch.svg": 29084,
	"./youtubecolorround.svg": 5219
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51006;